module.exports = __webpack_public_path__ + "img/front_fire_normal.31a20fba.png";